<template>
<div>
  <div class="section-header">Your Sub Domain</div>
  <div class="card card--white">
    <div class="card--container">
      <subdomain v-if="subDomain.id" class="section-bottom" @save="save" :subDomain="subDomain" :saving="saving">
        <h-input type='checkbox' label='Incredible Coaching Associate' v-model='subDomain.show_on_search' />
        <div >
          <div>
            In order to start taking payments directly from your customers we need to connect with your Stripe account
          </div>
          <a :href="stripeAuthLink">Connect With Stripe</a>
        </div>
      </subdomain>
    </div>
  </div>
  <impersonate class="small-top"/>
</div>
</template>

<script>
import subdomain from "@/components/subDomain";
import store from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import { storeSubdomain } from "@/services/api/subDomains";
import impersonate from "./impersonate";
import modal from "@/components/modal/default";

export default {
  components: { subdomain, impersonate, modal },
  data() {
    return {
      subDomain: {},
      saving: false,
      stripeModal: false,
      error: false,
      success: false
    };
  },
  created() {
    store.findAll("OwnerSubDomains").then(r => {
      this.subDomain = r[0];
    });
  },
  methods: {
    save(company) {
      this.saving = true;
      company.show_on_search = this.subDomain.show_on_search
      store
        .update("OwnerSubDomains", this.subDomain.id, company)
        .then(r => {
          snackbar.update("Saved");
          storeSubdomain(r);
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
  computed: {
    stripeAuthLink() {
      return `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.VUE_APP_STRIPE_CLIENT_ID}&scope=read_write`
    }
  }
};
</script>
